<h2 mat-dialog-title>Informacion adicional del medicamento</h2>
<mat-dialog-content>
  <!-- Documentos -->
  <section *ngIf="loadingDocs || documents.length">
    <h3 class="subtitle"><mat-icon class="icon-doc">description</mat-icon> Documentos oficiales</h3>
    <div *ngIf="loadingDocs">Cargando documentos...</div>
    <div *ngIf="!loadingDocs && documents.length === 0">
      <span class="empty-label">No hay documentos disponibles.</span>
    </div>
    <div *ngIf="!loadingDocs && documents.length > 0">
      <div class="docs-row">
        <button mat-raised-button
                *ngFor="let doc of documents"
                class="doc-btn"
                color="primary"
                (click)="openDocument(doc)">
          <mat-icon class="icon-doc">description</mat-icon>
          {{ doc.documentName }}
        </button>
      </div>
    </div>
  </section>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cerrar</button>
</mat-dialog-actions>
